import { MENU_ROW_END_PAD_CLASS } from '@features/sidebar/components/menuIconSlots'

// Matches the table drawer's row menu, above the sidebar's own stacking layer.
export const SIDEBAR_DROPDOWN_Z_INDEX = 10001

// A row, selected and hovered like the rail's items (the sidebar-item tokens).
export const ROW_CLASS = `group relative flex min-h-[var(--sidebar-tile-size)] w-full min-w-0 items-center rounded-md pl-2 ${MENU_ROW_END_PAD_CLASS} text-sm`
export const ROW_STATE_CLASS = {
  active:
    'bg-[color:var(--sidebar-item-active-bg)] font-medium text-[color:var(--sidebar-item-active-text)] hover:bg-[color:var(--sidebar-item-active-hover-bg)]',
  idle: 'text-[color:var(--sidebar-submenu-text-data)] hover:bg-[color:var(--sidebar-item-hover-bg)]',
}
export const NOTE_CLASS = 'px-2 py-2 text-sm text-[color:var(--sidebar-submenu-text-muted)]'
export const NAME_INPUT_CLASS =
  'w-full rounded border border-[color:var(--sidebar-submenu-input-border)] bg-transparent px-1.5 py-1 text-sm text-[color:var(--sidebar-submenu-text-default)] outline-none focus:border-[color:var(--border-info)]'
